import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import GrantsByCity from "@/pages/GrantsByCity";

export const Route = createFileRoute("/grants/city/$city")({
  head: ({ params }) => seoHead(`/grants/city/${params.city}`),
  component: GrantsByCity,
});
